module.exports = __webpack_public_path__ + "img/ksh13.f5f8df9e.png";